import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardTitle } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Sticker } from '@cordata/buffet';

import formatPhone from '~/utils/format/phone';

const CareTeamCard = ({ data, onClick }) => {
  return (
    <Card className="p-3 border-primary">
      <div className="d-flex">
        <div className="flex-shrink-0 text-muted">
          <FontAwesomeIcon icon="user" size="2x" fixedWidth />

          {data.isPrimary && <div className="text-center"><FontAwesomeIcon icon="star" fixedWidth className="text-secondary pt-2" /></div>}
        </div>

        <div className="flex-grow-1 ms-3 ml-3 text-truncate">
          <CardTitle className="d-block text-truncate font-weight-bold cursor-pointer" onClick={() => onClick(data)}>
            {data.lastName}, {data.firstName}
          </CardTitle>

          <div>
            {data.roles && (<div><Sticker icon="user">{data.roles}</Sticker></div>)}
            {data.mobilePhone && (<div><Sticker icon="mobile-alt"><a href={`tel:${data.mobilePhone}`}>{formatPhone(data.mobilePhone)}</a></Sticker></div>)}
            {data.homePhone && (<div><Sticker icon="home"><a href={`tel:${data.homePhone}`}>{formatPhone(data.homePhone)}</a></Sticker></div>)}
            {data.email && (<div><Sticker icon="at"><a href={`mailto:${data.email}`}>{data.email}</a></Sticker></div>)}
          </div>
        </div>
      </div>
    </Card>
  );
};

CareTeamCard.propTypes = {
  data: PropTypes.shape().isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CareTeamCard;
